import {course_getTeachers_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import ContainerPicker from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import {renderIf} from "../../../Shared";

export const TeacherSelector = ({
  name,
  value,
  owner_id,
  owner_type,
  onChange = NullAsDefault,
  ...props
}) => {
  const t = useTranslate()
  const defaultValue = getId(value) ?? value;

  return (
    <ContainerPicker
      name={name}
      allowClear={true}
      defaultValue={defaultValue}
      type={AppEntities.UNDEFINED}
      placeholder="click to select"
      renderInnerWrapper={InnerWrapper}
      onOptionChange={(option) => {
        onChange(createValue(name, option ?? null))
      }}
      renderOption={renderBaseOption(defaultValue, (option) => ({
          title: (
              <div className="text-sm space-x-1">
                  {renderIf(
                      option?.prefix_title,
                      <span className="font-normal text-color-200 italic">{option?.prefix_title}{'.'}</span>
                  )}
                  <span className="font-bold text-color-000">{option?.fullname}</span>
              </div>
          ),
          description: <span className="text-green-300">{t(getType(option))}</span>,
      }))}
      customConfigs={{
        apiInfo: course_getTeachers_Api,
        query: bindQueryParams([{ id: owner_id }, { type: owner_type }]),
      }}
      {...props}
    />
  )
}
